/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Document_Type_InvoiceInputs */

const en_document_type_invoice = /** @type {(inputs: Document_Type_InvoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoice`)
};

/**
* | output |
* | --- |
* | "Invoice" |
*
* @param {Document_Type_InvoiceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const document_type_invoice = /** @type {((inputs?: Document_Type_InvoiceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Document_Type_InvoiceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_document_type_invoice(inputs)
});